import { render, staticRenderFns } from "./MonitorCard.vue?vue&type=template&id=2b94c15a&"
import script from "./MonitorCard.vue?vue&type=script&lang=js&"
export * from "./MonitorCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports